export const LEGAL_CONFIG = {
  companyName: '[Company Name] AB',
  companyOrgNumber: '559XXX-XXXX',
  companyAddress: '[Street Address], [Postcode] [City], Sweden',
  companyCountry: 'Sweden',
  companyJurisdiction: 'Swedish law',
  companyArbitrationVenue: 'Stockholm',

  productName: 'Rekrytering',
  websiteUrl: 'https://[domain].com',

  privacyEmail: 'privacy@[domain].com',
  supportEmail: 'support@[domain].com',
  legalEmail: 'legal@[domain].com',

  dataRetentionDays: 180,
  auditLogRetentionDays: 180,
} as const

type LegalVersion = {
  readonly version: string
  readonly effectiveDate: string
  readonly lastModified: string
  readonly changes: string
}

type LegalPageHistory = {
  readonly current: LegalVersion
  readonly history: readonly LegalVersion[]
}

export const LEGAL_VERSIONS = {
  privacy: {
    current: {
      version: '1.0',
      effectiveDate: '2025-01-01',
      lastModified: '2025-01-01',
      changes: 'Initial publication.',
    },
    history: [],
  },
  cookies: {
    current: {
      version: '1.0',
      effectiveDate: '2025-01-01',
      lastModified: '2025-01-01',
      changes: 'Initial publication.',
    },
    history: [],
  },
  terms: {
    current: {
      version: '1.0',
      effectiveDate: '2025-01-01',
      lastModified: '2025-01-01',
      changes: 'Initial publication.',
    },
    history: [],
  },
  dpa: {
    current: {
      version: '1.0',
      effectiveDate: '2025-01-01',
      lastModified: '2025-01-01',
      changes: 'Initial publication.',
    },
    history: [],
  },
  subprocessors: {
    current: {
      version: '1.0',
      effectiveDate: '2025-01-01',
      lastModified: '2025-01-01',
      changes: 'Initial publication.',
    },
    history: [],
  },
} as const satisfies Record<string, LegalPageHistory>
